module.exports = __webpack_public_path__ + "img/Layer-0.a791ac36.webp";